import React, { Component, PureComponent } from "react";
import PageHeaderWrapper from "../../components/PageHeaderWrapper";
import { FormUtils as GetAllFormFields, TableComp } from 'sz-react-utils'
import { Button, Card, Drawer, Form, notification, Select, Switch, Tabs, Tooltip, Row, Col, Input, List, } from 'antd'
import _ from 'lodash';
import { hideLoader, showLoader } from "../../modules/actions";
import Request, { API_URL } from "../../request";
import { connect } from "react-redux";
import { getUrlPushWrapper } from "../../routes";
import setting from "../../components/_utils/settings";
import Moment from "moment";
import { FaUserCog } from "react-icons/fa";
import { RightsWrapper } from "../../components/_utils/utils";
import SyncEmployeeDetailsForm from "../../components/_utils/syncEmployeeDetailsForm";
import moment from "moment";
import { AiFillCheckSquare } from "react-icons/ai";
import ViewEmployeeDetails from "../../components/_utils/viewEmployeeDetails";
import rightAuth from '../../components/_utils/userRights'
let accountPaymentCompanies = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')) : '';

const Option = Select.Option
const TabPane = Tabs.TabPane

// To Change Password
@Form.create()
class ChangePassword extends Component {
    handleSubmit = e => {
        const { dispatch, form } = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                this.props.handleSubmit(valData)
            }
        })
    }
    render() {
        const { dispatch } = this.props

        const {
            form: { getFieldDecorator, getFieldValue, setFieldsValue }
        } = this.props

        let inputTypes = {
            fields: [
                {
                    label: 'Password',
                    key: 'password',
                    type: 'password',
                    required: true
                },
                {
                    label: 'Confirm Password',
                    key: 'cpassword',
                    type: 'password',
                    required: true
                }
            ]
        }
        return (
            <div>
                <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                    <GetAllFormFields
                        inputSchema={inputTypes}
                        getFieldDecorator={getFieldDecorator}
                    />
                    <Button
                        type="primary"
                        htmlType="submit"
                        style={{ marginBottom: 10, marginLeft: '33%' }}
                        loading={this.props.loading}>
                        SAVE
                    </Button>
                </Form>
            </div>
        )
    }
}

@Form.create()
class AllEmployees extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            id: '',
            changePasswordRecord: [],
            drawerVisible: false,
            expierenceLetterIssued: false,
            activeStatus: '',
            releivingAvialable: false,
            userGroup: '',
            showSyncForm: false,
            user: [],
            allUser: [],
            branches: [],
            detailDrawerVisible: false,
            maritalStatus: false,
            maritalStatuses: [],
            lessSalaryAndMarried: false,
            viewDetailRecord: [],
            ishod: false,
            hodList: [],
            activeUser: {},
            companySetting: {},
            shiftTimingArr: [],
            laptops: [],
            mobiles: [],
            havePreviousExperience: false,
            departments: [],
            phoneCodes: [],
            workingDays: [{ id: "Monday", display: "Monday" }, { id: "Tuesday", display: "Tuesday" }, { id: "Wednesday", display: "Wednesday" },
            { id: "Thursday", display: "Thursday" }, { id: "Friday", display: "Friday" }, { id: "Saturday", display: "Saturday" }, { id: "Sunday", display: "Sunday" }]
        }
        this.table = React.createRef()
    }


    loadShiftTiming = async () => {
        let params = {
            results: 1000,
            count: 1000
        }
        let response = await Request.getAllShiftTimings(params)
        let shiftTimingArr = []
        _.each(response.data, (item) => {
            shiftTimingArr.push({ id: item.shiftTime, display: item.shiftTime })
        })
        this.setState({ shiftTimingArr })
    }
    fetchAllHod = async () => {
        let params = {}
        params.sortField = 'dateOfJoining'
        params.sortOrder = 'ascend'
        params.userBranch = this.state.activeUser.userBranch
        params.active = true
        params.userType = { $ne: "Student" }
        params.isHOD = true
        let { data } = await Request.loadUser({ ...params, regExFilters: ['name', 'email'] })
        let hodList = []
        _.each(data, (item) => {
            hodList.push({ _id: item._id, display: item.name })
        })
        this.setState({ hodList })

    }

    loadMaritalStatus = async () => {
        let params = {
            results: 1000,
            count: 1000
        }
        let response = await Request.getMaritalStatusDetails(params)
        let maritalStatuses = []
        _.each(response.data, (item) => {
            maritalStatuses.push({ _id: item.maritalStatus, display: item.maritalStatus })
        })
        this.setState({ maritalStatuses })
    }

    loadCompanyAssets = async () => {
        let params = {
            results: 10000,
            count: 10000,
            assetStatus: "Unassigned"
        }
        let laptops = []
        let mobiles = []
        let response = await Request.getAllCompanyAssets(params)
        _.each(response.data, (item) => {
            if (item.assetType === "Laptop" || item.assetType === "Laptop") {
                laptops.push({ _id: item._id, display: `${item.assetNumber} - ${item.assetName}` })
            } else if (item.assetType === "Mobile") {
                mobiles.push({ _id: item._id, display: `${item.assetNumber} - ${item.assetName}` })
            }
        })
        this.setState({ laptops, mobiles })
    }

    loadDepartments = async () => {
        let params = {
            results: 1000,
            count: 1000
        }
        let response = await Request.getAllDepartments(params)
        let departments = []
        _.each(response.data, (item) => {
            departments.push({ id: item.departmentName, display: item.departmentName })
        })
        this.setState({ departments })
    }

    loadCountries = () => {

        let params = {
            results: 100,
            sortField: "countryName",
            sortOrder: "ascend",
        };
        Request.getCountriesWithoutAuth({ ...params })
            .then((resp) => {

                let phoneCodes = [];
                resp.data = resp.data.reduce((temp, vv) => {

                    if (vv.countryPhoneCode) {
                        phoneCodes.push({ id: vv.countryPhoneCode, display: vv.countryPhoneCode });
                    }
                    temp.push({ ...vv });
                    return temp;
                }, []);
                this.setState({ phoneCodes: phoneCodes });
            })
            .catch((err) => {
                console.log(err);
            });
    };

    loadApis = async () => {
        // let response = await Request.loadEmployeeMasterData();
        // console.log(response);
    }

    async componentDidMount() {
        this.loadApis()
        this.loadCountries()
        this.loadMaritalStatus()
        this.fetchAllHod()
        this.loadShiftTiming()
        this.getCurrentUser()
        this.loadDepartments()
        this.loadCompanyAssets()

        let allUsers = []
        const { dispatch } = this.props
        let params = {
            results: 200,
            count: 200
        }
        let users = await this.loadUsers(params, 'user')
        users.data.map((user) => {
            allUsers.push({ _id: user._id, display: user.name })
        })
        this.setState({ allUsers })
        let searchParams = new URLSearchParams(this.props.search)
        let userId = searchParams.get('id')
        this.setState({
            id: userId
        })
        dispatch(showLoader())
        if (userId) {
            Request.getUserById({ id: userId }).then(({ _doc: data, error, message }) => {
                if (!error) {
                    this.setState({
                        id: data._id,
                        userGroup: data.userGroup._id
                    })
                    if (data.experienceLetter === "Issued") {
                        this.setState({ expierenceLetterIssued: true })
                    }
                    if (data.dateOfRelieving) {
                        this.setState({ releivingAvialable: true })
                    }
                    const isShowCountry = data && data.isCounsellor;
                    this.setState({ isShowCountry: isShowCountry, user: data })
                    this.setState({ activeStatus: (data && data.activeStatus) })
                    if (data.isHOD === true) {
                        this.setState({ ishod: true })
                    }
                    if (data.maritalStatus === 'Married') {
                        this.setState({ maritalStatus: true })
                    } else if (data.maritalStatus === "Unmarried") {
                        this.setState({ maritalStatus: false });
                    }

                    if (data.currentSalary === "21000 or Less" && this.state.maritalStatus === true) {
                        this.setState({ lessSalaryAndMarried: true });
                    } else if (data.currentSalary === "21000 or Less" && this.state.maritalStatus === false) {
                        this.setState({ lessSalaryAndMarried: false });
                    } else {
                        this.setState({ lessSalaryAndMarried: null });
                    }

                    if (data.havePreviousExperience) {
                        this.setState({ havePreviousExperience: data.havePreviousExperience }, () => {
                            this.props.form.setFieldsValue({
                                havePreviousExperience: data && data.havePreviousExperience,
                                previousEmployerName: data && data.previousEmployerName,
                                previousCompanyName: data && data.previousCompanyName,
                                previousDuration: data && data.previousDuration,
                                previousSalary: data && data.previousSalary,
                                uanNumber: data && data.uanNumber,
                                referenceName: data && data.referenceName,
                                referenceNumber: data && data.referenceNumber,
                            })
                        })
                    }
                    setTimeout(() => {
                        this.props.form.setFieldsValue({
                            bankName: data.bankDetails && data.bankDetails.bankName,
                            accountNumber: data.bankDetails && data.bankDetails.accountNumber,
                            ifsc: data.bankDetails && data.bankDetails.ifsc,
                            accountName: data.bankDetails && data.bankDetails.accountName,
                            name: data && data.name,
                            permanentAddress: data && data.permanentAddress,
                            temporaryAddress: data && data.temporaryAddress,
                            contactNo: data && data.contactNo,
                            personalEmail: data && data.personalEmail,
                            emergencyPhone: data && data.emergencyPhone,
                            emergencyPerson: data && data.emergencyPerson,
                            dob: data && moment(data.dob),
                            fatherName: data && data.fatherName,
                            aadharNumber: data && data.aadharNumber,
                            panNumber: data && data.panNumber,
                            department: data && data.department,
                            sibling: data && data.sibling,
                            medicalIllness: data && data.medicalIllness,
                            salary: data && data.salary,
                            childrenName: data && data.childrenName,
                            childrenDob: data && moment(data.childrenDob),
                            motherName: data && data.motherName,
                            motherDob: data && moment(data.motherDob),
                            fatherDob: data && moment(data.fatherDob),
                            siblingName: data && data.siblingName,
                            siblingDob: data && moment(data.siblingDob),
                            highestQualification: data && data.highestQualification,
                            universityorCollege: data && data.universityorCollege,

                            husbandWifeDob: data && data.husbandWifeDob,
                            husbandWifeName: data && data.husbandWifeName,
                            maritalStatus: data && data.maritalStatus,
                            emailPass: data && data.emailPass,
                            laptopNumber: data && data.laptopNumber,
                            laptopModel: data && data.laptopModel,
                            mobileSerial: data && data.mobileSerial,
                            otherOfficialAsset: data && data.otherOfficialAsset,
                            empId: data && data.empId,
                            hireAs: data && data.hireAs,
                            dateOfJoining: data && moment(data.dateOfJoining),
                            appointmentCert: data && data.appointmentCert,
                            policies: data && data.policies,
                            employeeAgreementCert: data && data.employeeAgreementCert,
                            appraisalCert: data && data.appraisalCert,
                            shiftTiming: data && data.shiftTiming,
                            joiningSalary: data && data.joiningSalary,
                            activeStatus: data && data.activeStatus,
                            userHOD: data && data.userHOD,
                            isHOD: data && data.isHOD,
                            teamIds: data && data.teamIds,
                            resignationDate: data && moment(data.resignationDate),
                            terminationDate: data && moment(data.terminationDate),
                            abscondDate: data && moment(data.abscondDate),
                            dateOfRelieving: data && moment(data.dateOfRelieving),
                            relievingCert: data && data.relievingCert,
                            fullFinalSettlementDue: data && data.fullFinalSettlementDue,
                            experienceLetter: data && data.experienceLetter,
                            experienceCert: data && data.experienceCert,
                            letterOfIntent: data && data.letterOfIntent,
                            noDueCert: data && data.noDueCert,
                            aadharCard: data && data.aadharCard,
                            panCard: data && data.panCard,
                            workingDays: data && data.workingDays,
                            academicCertificates: data && data.academicCertificates,
                            experienceCert: data && data.experienceCert,
                            salarySlip: data && data.salarySlip,
                            medicalIllnessCert: data && data.medicalIllnessCert,
                            bankPassbook: data && data.bankPassbook,
                            photo: data && data.photo
                        })
                    }, 500)


                    this.setState({
                        bankInfo: {
                            bankName: data && data.bankDetails && data.bankDetails.bankName,
                            branchNameAddress: data && data.bankDetails && data.bankDetails.branchNameAddress,
                            accountNumber: data && data.bankDetails && data.bankDetails.accountNumber,
                            accountName: data && data.bankDetails && data.bankDetails.accountName,
                            ifsc: data && data.bankDetails && data.bankDetails.ifsc
                        }
                    })
                    if (data && data.seniorityBonus && data.seniorityBonus.length > 0) {
                        this.setState({ seniorityBonus: data.seniorityBonus })
                    }
                    if (data && data.operationManagerIncentive && data.operationManagerIncentive.length > 0) {
                        this.setState({ operationManagerIncentive: data.operationManagerIncentive })
                    }


                } else {
                    notification.error({
                        message: 'Error Getting Data',
                        description: message
                    })
                }
            })
        }
        dispatch(hideLoader())
    }

    callback = (key) => {

    }

    closeDetailForm = () => {
        this.setState({ detailDrawerVisible: false, viewDetailRecord: {} })
    }

    closeSyncForm = () => {
        this.setState({ showSyncForm: false });
    }

    changeUserApporval = async ({ checked, _id }) => {
        let response = await Request.approveUser({ _id, active: checked })
        if (response.error) {
            notification.error({
                message: response.message
            })
        } else {
            notification.success({
                message: 'User Updated'
            })
        }
        this.table.current.reload();
    }

    changeVerifyIPOnly = async ({ checked, _id }) => {
        await Request.changeVerifyIPOnly({ _id, verifyIP: checked })
        this.table.current.reload();
    }
    changeEditedByUser = async ({ checked, _id }) => {
        await Request.changeEditedByUser({ _id, editedByUser: checked })
        this.table.current.reload()
    }

    loadUsers = (params, userType = 'user') => {
        return new Promise(async resolve => {
            if (!params) {
                params = {}
            }
            params.sortField = 'dateOfJoining'
            params.sortOrder = 'ascend'
            params.active = true
            params.userType = { $ne: "Student" }
            let data = await Request.loadEmployeeUser({ ...params, regExFilters: ['name', 'email'] })
            this.setState({ totalUser: data.total })
            resolve(data)
        })
    }

    async handleGenerateExperience(user) {
        let response = await Request.generateExpiernceLetter(user);
        if (!response.error) {
            notification.success({
                message: response.msg
            })
        } else {
            notification.error({
                message: response.msg
            })
        }
    }

    async handleGenerateAgreement(user) {
        let response = await Request.generateEmployeeAgreement(user);
        if (!response.error) {
            notification.success({
                message: response.msg
            })
        } else {
            notification.error({
                message: response.msg
            })
        }
    }

    async handleGenerateAppraisal(user) {
        let response = await Request.generateAppraisalLetter(user)
        if (!response.error) {
            notification.success({
                message: response.msg
            })
        } else {
            notification.error({
                message: response.msg
            })
        }
    }

    handleSalaryUpdate = (data) => {
        if (data === "21000 or Less" && this.state.maritalStatus === true) {
            this.setState({ lessSalaryAndMarried: true });
        } else if (data === "21000 or Less" && this.state.maritalStatus === false) {
            this.setState({ lessSalaryAndMarried: false });
        } else {
            this.setState({ lessSalaryAndMarried: null });
        }
    };

    async handleGenerateAppointmentLetter(user) {
        let response = await Request.generateAppointmentLetter(user);
        if (!response.error) {
            notification.success({
                message: response.msg
            })
        } else {
            notification.error({
                message: response.msg
            })
        }
    }

    getCurrentUser = async () => {
        let response = JSON.parse(localStorage.getItem('user'))
        let branches = [];
        if (response.branchesManaging && response.branchesManaging.length > 0) {
            _.each(response.branchesManaging, async (branch) => {
                let response = await Request.getBranch(branch)
                branches.push({ id: response.doc._id, display: response.doc.branchName })
            })
        }
        let companySettingResponse = await Request.getCompanySetting({ businessId: response.businessId })
        this.setState({ activeUser: response, branches, companySetting: companySettingResponse })
    }


    exportExcel = async () => {
        let x = await Request.exportUsersToExcel({
            regExFilters: ['name'
            ]
        })
        if (!x.error) {
            window.open(x.url)
        }
    }

    handleSubmit = (e) => {
        const { dispatch, form } = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let response = null
                let values = _.clone(valData);
                dispatch(showLoader())
                if (!values.userBranch) {
                    values.userBranch = this.state.activeUser.userBranch
                }
                const bankInfo = {
                    bankName: values.bankName, branchNameAddress: values.branchNameAddress, accountNumber: values.accountNumber,
                    accountName: values.accountName, ifsc: values.ifsc
                };
                values.bankDetails = bankInfo;
                this.setState({ bankInfo: bankInfo });
                values._id = this.state.id;
                delete values.bankName;
                delete values.branchNameAddress;
                delete values.accountName;
                delete values.accountNumber;
                delete values.ifsc;
                if (this.state.id) {
                    values._id = this.state.id
                    values.userGroup = this.state.userGroup
                    values.userMobile = this.state.user.userMobile
                    values.email = this.state.user.email

                    response = await Request.updateUser(values)
                } else {
                    response = await Request.addUser(values)
                }

                dispatch(hideLoader())
                if (!response.error) {
                    notification.success({
                        message: response.msg
                    })
                } else {
                    notification.error({
                        message: response.msg
                    })
                }
            }
        })
    }
    handleMaritalStatus = (data) => {
        if (data === "Married") {
            this.setState({ maritalStatus: true });
        } else {
            this.setState({ maritalStatus: false });
        }
    };

    render() {
        const { id, changePasswordRecord, havePreviousExperience, departments, companySetting, shiftTimingArr, branches, drawerVisible, viewDetailRecord, maritalStatus, lessSalaryAndMarried, hodList, expierenceLetterIssued, detailDrawerVisible, releivingAvialable, activeStatus, user } = this.state
        const {
            dispatch,
            form: { getFieldDecorator, getFieldValue, setFieldsValue }
        } = this.props
        console.log(accountPaymentCompanies);
        let accountPaymentCompaniesArray = [];
        if (accountPaymentCompanies && accountPaymentCompanies.accountPaymentCompanies && accountPaymentCompanies.accountPaymentCompanies.indexOf(',')) {
            accountPaymentCompaniesArray = accountPaymentCompanies.accountPaymentCompanies.split(',');
            accountPaymentCompaniesArray.splice(0, 0, accountPaymentCompanies.companyName)
        }


        let BankDetailInputTypes = {
            fields: [
                {
                    label: "Bank Name",
                    key: "bankName",
                    type: "text",

                },
                {
                    label: "Bank Account No.",
                    key: "accountNumber",
                    type: "text",

                },
                {
                    label: "IFSC Code",
                    key: "ifsc",
                    type: "text",

                },
                {
                    label: "Name as Bank Account",
                    key: "accountName",
                    type: "text",

                }
            ],
        };
        let generalInformationInputTypes = {
            fields: [
                {
                    label: "Name",
                    type: "text",
                    key: "name",

                },
                {
                    label: "Permanent Address With Pincode",
                    type: "address",
                    key: "permanentAddress",

                },
                {
                    label: "Current Address with Pincode",
                    type: "address",
                    key: "temporaryAddress",

                },
                {
                    label: 'Personal Contact Number Code',
                    type: 'select',
                    key: 'contactNoCode',
                    options: this.state.phoneCodes,
                    onChange: v => {
                        this.props.form.setFieldsValue({ contactNoCode: v })
                    }
                },
                {
                    label: "Personal Contact Number",
                    type: "text",
                    key: "contactNo",
                },
                {
                    label: "Personal Email Id",
                    type: "email",
                    key: "personalEmail",
                },
                {
                    label: 'Emergency Number Code',
                    type: 'select',
                    key: 'emergencyPhoneCode',
                    options: this.state.phoneCodes,
                    onChange: v => {
                        this.props.form.setFieldsValue({ emergencyPhoneCode: v })
                    }
                },
                {
                    label: "Emergency Number",
                    type: "text",
                    key: "emergencyPhone",

                },
                {
                    label: `Emergency Contact Person`,
                    type: "text",
                    key: "emergencyPerson",

                },
                {
                    label: "Date of Birth",
                    type: "date",
                    key: "dob",

                },
                {
                    label: `Father's Name`,
                    type: "text",
                    key: "fatherName",

                },
                {
                    label: "Marital Status",
                    type: "select",
                    key: "maritalStatus",
                    options: this.state.maritalStatuses,

                    onChange: (v) => {
                        this.props.form.setFieldsValue({ maritalStatus: v });
                        this.handleMaritalStatus(v);
                    },
                },
                {
                    label: "Husband/Wife Name",
                    type: "text",
                    key: "husbandWifeName",
                    hidden: !maritalStatus,
                    required: maritalStatus,
                },
                {
                    label: "Aadhar Number",
                    type: "text",
                    key: "aadharNumber",

                },
                {
                    label: "Pan Number",
                    type: "text",
                    key: "panNumber",

                },
                {
                    label: "Any Sibling",
                    type: "select",
                    key: "sibling",
                    options: ["Yes", "No"],
                    onChange: v => {
                        this.props.form.setFieldsValue({ sibling: v })
                    }
                },
                {
                    label: "Any Medical Illness",
                    type: "text",
                    key: "medicalIllness",
                },
                {
                    label: "Current Salary",
                    type: "select",

                    key: "salary",
                    options: ["21000 or Less", "More than 21000"],
                    onChange: (v) => {
                        this.props.form.setFieldsValue({ salary: v });
                        this.handleSalaryUpdate(v);
                    },
                },
                {
                    label: "Husband/Wife DOB",
                    type: "date",
                    key: "husbandWifeDob",
                    hidden: !lessSalaryAndMarried,
                    required: lessSalaryAndMarried,
                },
                {
                    label: "Children Name",
                    prefixComp: "Children Details (if Any)",
                    type: "text",
                    key: "childrenName",
                    hidden: !lessSalaryAndMarried,
                },
                {
                    label: "Children DOB",
                    type: "date",
                    key: "childrenDob",
                    hidden: !lessSalaryAndMarried,
                },
                {
                    label: `Mother's Name`,
                    type: "text",
                    key: "motherName",
                    hidden: lessSalaryAndMarried === null ? true : lessSalaryAndMarried,
                    required:
                        !lessSalaryAndMarried === null ? true : !lessSalaryAndMarried,
                },
                {
                    label: `Mother's DOB`,
                    type: "date",
                    key: "motherDob",
                    hidden: lessSalaryAndMarried === null ? true : lessSalaryAndMarried,
                    required:
                        !lessSalaryAndMarried === null ? true : !lessSalaryAndMarried,
                },

                {
                    label: `Father's DOB`,
                    type: "date",
                    key: "fatherDob",
                    hidden: lessSalaryAndMarried === null ? true : lessSalaryAndMarried,
                    required:
                        !lessSalaryAndMarried === null ? true : !lessSalaryAndMarried,
                },
                {
                    label: "Sibling Name",
                    prefixComp: "Sibling Details (if Any)",
                    key: "siblingName",
                    hidden: lessSalaryAndMarried === null ? true : lessSalaryAndMarried,
                },
                {
                    label: "Sibling DOB",
                    type: "date",
                    key: "siblingDob",
                    hidden: lessSalaryAndMarried === null ? true : lessSalaryAndMarried,
                },
            ],
        };
        let academicDetailInputTypes = {
            fields: [
                {
                    label: "Highest Qualification",
                    type: "text",
                    key: "highestQualification",

                },
                {
                    label: "University/College",
                    type: "text",
                    key: "universityorCollege",

                },
            ],
        };
        let previousExpierenceInputTypes = {
            fields: [
                {
                    label: 'Have Experience?',
                    type: 'switch',
                    key: 'havePreviousExperience',
                    onChange: v => {
                        this.props.form.setFieldsValue({ havePreviousExperience: v })
                        this.setState({ havePreviousExperience: v })
                    }
                },
                {
                    label: "Last Employer Name",
                    type: "text",
                    key: "previousEmployerName",
                    hidden: !havePreviousExperience,
                    required: havePreviousExperience

                },
                {
                    label: "Last Company Name",
                    type: "text",
                    key: "previousCompanyName",
                    hidden: !havePreviousExperience,
                    required: havePreviousExperience

                },
                {
                    label: "Duration",
                    type: "text",
                    key: "previousDuration",
                    hidden: !havePreviousExperience,
                    required: havePreviousExperience

                },
                {
                    label: "Last Salary",
                    type: "text",
                    key: "previousSalary",
                    hidden: !havePreviousExperience,
                    required: havePreviousExperience
                },
                {
                    label: "UAN Number",
                    type: "text",
                    key: "uanNumber",
                    hidden: !havePreviousExperience,
                },
                {
                    label: 'Reference Name',
                    type: 'text',
                    key: 'referenceName',
                    hidden: !havePreviousExperience,
                    required: havePreviousExperience
                },
                {
                    label: 'Reference Number',
                    type: 'text',
                    key: 'referenceNumber',
                    hidden: !havePreviousExperience,
                    required: havePreviousExperience
                }
            ],
        };
        let currentEmploymentInputTypes = {
            fields: [
                {
                    label: "Official Email Password",
                    type: "text",
                    key: "emailPass",

                },
                {
                    label: "Laptop Serial Number",
                    type: "text",
                    key: "laptopNumber",

                },
                {
                    label: 'Official Mobile Serial',
                    type: 'text',
                    key: 'mobileSerial',
                },
                {
                    label: "Laptop Model",
                    type: "text",
                    key: "laptopModel",

                },
                {
                    label: "Any Other Asset",
                    type: "text",
                    key: "otherOfficialAsset",

                },
            ],
        };
        let documentsRequiredInputTypes = {
            fields: [
                {
                    label: "Aadhar Card",
                    type: "file",
                    key: "aadharCard",
                    limit: 1,
                    defaultFileList: [],
                },
                {
                    label: "Pan Card",
                    type: "file",
                    key: "panCard",
                    limit: 1,
                    defaultFileList: [],
                },
                {
                    label: "All Academic Certificates",
                    type: "file",
                    key: "academicCertificates",
                    limit: 1,
                    defaultFileList: [],
                },
                {
                    label: "Previous Experience Letter",
                    type: "file",
                    key: "experienceCert",
                    limit: 1,
                    defaultFileList: [],
                },
                {
                    label: "3 Months Salary Slip",
                    type: "file",
                    key: "salarySlip",
                    limit: 1,
                    defaultFileList: [],
                },
                {
                    label: "Medical Illness Certificate",
                    type: "file",
                    key: "medicalIllnessCert",
                    limit: 1,
                    defaultFileList: [],
                },
                {
                    label: "Bank Passbook",
                    type: "file",
                    key: "bankPassbook",
                    limit: 1,
                    defaultFileList: [],
                },
                {
                    label: "Passport Size Photo",
                    type: "file",
                    key: "photo",
                    limit: 1,
                    defaultFileList: [],
                },
            ],
        };
        const onBoardingInputTypes = {
            fields: [
                { label: 'Employee ID', key: 'empId' },
                { label: 'Hired AS', key: 'hireAs' },
                {
                    label: 'Department', key: 'department', type: 'select', options: departments, onChange: v => {
                        this.props.form.setFieldsValue({ department: v })
                    }
                },
                { label: 'Date of Joining', key: 'dateOfJoining', type: 'date' },
                { label: 'Appointment Letter', key: 'appointmentCert', type: 'file' },
                { label: 'Policies', key: 'policies', type: 'file' },
                { label: 'Employee Agreement', key: 'employeeAgreementCert', type: 'file' },
                { label: 'Appraisal Letter', key: 'appraisalCert', type: 'file' },
                {
                    label: 'Shift Timing',
                    key: 'shiftTiming',
                    type: 'select',
                    options: shiftTimingArr,
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            shiftTiming: v
                        })
                    }
                },
                {
                    label: 'Working Days',
                    key: 'workingDays',
                    type: 'select',
                    mode: 'multiple',
                    options: this.state.workingDays,
                    onChange: v => {
                        this.props.form.setFieldsValue({ workingDays: v })
                    }
                },
                {
                    label: 'Laptop/Desktop Number', key: 'laptopNumber', type: 'select', options: this.state.laptops, onChange: v => {
                        this.props.form.setFieldsValue({ laptopNumber: v })
                    }
                },
                {
                    label: 'Mobile Number', key: 'mobileNumber', type: 'select', options: this.state.mobiles, onChange: v => {
                        this.props.form.setFieldsValue({ mobileNumber: v })
                    }
                },
                { label: 'Joining Salary', key: 'joiningSalary', type: 'number', style: { width: "100%" }, disabled: this.state.activeUser.isAdministrator || this.state.activeUser.isFinanceAdmin ? false : true },
                { label: 'Salary', key: 'salary', type: 'number', disabled: this.state.activeUser.isAdministrator || this.state.activeUser.isFinanceAdmin ? false : true },
                {
                    label: 'Active Status',
                    key: 'activeStatus',
                    type: 'select',
                    options: ['Active', 'Resignation', 'Termination', 'Abscond'],
                    placeholder: 'Select Status',
                    onChange: v => {
                        this.setState({ activeStatus: v })
                        this.props.form.setFieldsValue({
                            activeStatus: v
                        })
                    }
                },
                {
                    label: 'Employee HOD',
                    key: 'userHOD',
                    type: 'select',
                    options: hodList,
                    hidden: this.state.ishod || companySetting && !companySetting.haveHeadOfDepartments,
                    mode: 'multiple',
                    onChange: v => {
                        this.props.form.setFieldsValue({ userHOD: v })
                    }
                },
                {
                    label: 'HOD?',
                    key: 'isHOD',
                    type: 'switch',
                    hidden: companySetting && !companySetting.haveHeadOfDepartments,
                    onChange: v => {
                        setFieldsValue({
                            isHOD: v
                        })
                        if (v === true) {
                            this.setState({ ishod: true })
                        } else if (v === false) {
                            this.setState({ ishod: false })
                        }
                    }
                },
                {
                    label: 'Select Team',
                    key: 'teamIds',
                    type: 'select',
                    options: this.state.allUsers,
                    hidden: !this.state.ishod,
                    mode: 'multiple',
                    showSearch: true,
                    onChange: val => {
                        this.props.form.setFieldsValue({ teamIds: val })
                    }
                }
            ]
        }
        const exitDetailsInputTypes = {
            fields: [
                { label: 'Resignation Date', key: 'resignationDate', type: 'date', hidden: (activeStatus == 'Resignation' ? false : true) },
                { label: 'Termination Date', key: 'terminationDate', type: 'date', hidden: (activeStatus == 'Termination' ? false : true) },
                { label: 'Abscond Date', key: 'abscondDate', type: 'date', hidden: (activeStatus == 'Abscond' ? false : true) },
                { label: 'Date Of Relieving', key: 'dateOfRelieving', type: 'date' },
                { label: 'Relieving Letter', key: 'relievingCert', type: 'file' },
                {
                    label: 'Full And Final Statement Due',
                    key: 'fullFinalSettlementDue',
                    type: 'select',
                    options: ['Pending', 'Cleared'],
                    placeholder: 'Select Status',
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            fullFinalSettlementDue: v
                        })
                    }
                },
                {
                    label: 'Experience Letter',
                    key: 'experienceLetter',
                    type: 'select',
                    options: ['Issued', 'Not Issued'],
                    placeholder: 'Select Option',
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            experienceLetter: v
                        })
                        if (v === 'Issued') {
                            this.setState({ expierenceLetterIssued: true })
                        } else if (v === 'Not Issued') {
                            this.setState({ expierenceLetterIssued: false })
                        }
                    }
                },
                {
                    label: 'Experience Certificate',
                    key: 'experienceCert',
                    type: 'file',
                    hidden: !expierenceLetterIssued,
                    required: expierenceLetterIssued
                },
                {
                    label: 'No Due Certificate',
                    key: 'noDueCert',
                    type: 'file'
                }
            ]
        }

        const inputTypes = {
            fields: [
                {
                    label: 'User Branch',
                    key: 'userBranch',
                    required: branches.length > 0,
                    hidden: !branches.length > 0,
                    type: 'select',
                    options: branches,
                    onChange: v => {
                        this.props.form.setFieldsValue({ userBranch: v })
                    }
                },
                { label: 'Name', key: 'name', required: true },
                { label: ' User Email', key: 'email', required: true },
                {
                    label: ' User Department', key: 'department', type: 'select', options: departments, required: true,
                    onChange: v => {
                        this.props.form.setFieldsValue({ department: v })
                    }
                },
                {
                    label: 'Company',
                    key: "company",
                    required: true,
                    type: 'select',
                    options: accountPaymentCompaniesArray,
                    onChange: v => {
                        this.props.form.setFieldsValue({ company: v })
                    }
                },
                {
                    label: 'Password',
                    key: 'password',
                    type: 'password',
                    hidden: (id ? true : false)
                },
                {
                    label: 'Official Mobile Phone Code',
                    key: 'userMobileCode',
                    required: true,
                    showSearch: true,
                    type: 'select',
                    options: this.state.phoneCodes,
                    onChange: v => {
                        this.props.form.setFieldsValue({ userMobileCode: v })
                    }
                },
                {
                    label: 'Official Mobile No',
                    key: 'userMobile',
                    required: true,
                    type: 'Number'
                },
                {
                    label: 'Employee ID',
                    key: 'empId',
                    type: 'text'
                },
                {
                    label: "Designation",
                    key: 'designation',
                    type: 'text'
                },
                {
                    label: 'Working Days',
                    key: 'workingDays',
                    type: 'select',
                    mode: 'multiple',
                    required: true,
                    options: this.state.workingDays,
                    onChange: v => {
                        this.props.form.setFieldsValue({ workingDays: v })
                    }
                },
                {
                    label: 'Joining Salary',
                    key: 'joiningSalary',
                    type: 'number',
                    required: true,
                    style: { width: "100%" }
                },
                {
                    label: 'Shift Timing',
                    key: 'shiftTiming',
                    type: 'select',
                    required: true,
                    options: shiftTimingArr,
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            shiftTiming: v
                        })
                    }
                },
                {
                    label: 'Alloted Laptop/Desktop Number',
                    key: 'laptopNumber',
                    type: 'select',
                    options: this.state.laptops,
                    onChange: v => {
                        this.props.form.setFieldsValue({ laptopNumber: v })
                    }
                },
                {
                    label: 'Alloted Mobile Number',
                    key: 'mobileNumber',
                    type: 'select',
                    options: this.state.mobiles,
                    onChange: v => {
                        this.props.form.setFieldsValue({ mobileNumber: v })
                    }
                },
                {
                    label: 'Employee HOD',
                    key: 'userHOD',
                    type: 'select',
                    options: hodList,
                    hidden: this.state.ishod || companySetting && !companySetting.haveHeadOfDepartments,
                    mode: 'multiple',
                    onChange: v => {
                        this.props.form.setFieldsValue({ userHOD: v })
                    }
                },
                {
                    label: 'Is HOD',
                    key: 'isHOD',
                    hidden: companySetting && !companySetting.haveHeadOfDepartments,
                    type: 'switch',
                    onChange: v => {
                        setFieldsValue({
                            isHOD: v
                        })
                        if (v === true) {
                            this.setState({ ishod: true })
                        } else if (v === false) {
                            this.setState({ ishod: false })
                        }
                    }
                },
                {
                    label: 'Select Team',
                    key: 'teamIds',
                    type: 'select',
                    options: this.state.allUsers,
                    hidden: !this.state.ishod,
                    mode: 'multiple',
                    showSearch: true,
                    onChange: val => {
                        this.props.form.setFieldsValue({ teamIds: val })
                    }
                }

            ]
        }

        const userColumn = [
            {
                title: 'Employee Id',
                dataIndex: 'empId',
                key: 'empId',
                searchTextName: 'empId',
                filterRegex: true,
                sorter: true
            },
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
                searchTextName: 'name',
                filterRegex: true,
                sorter: true,
                render: (val, record) => {
                    if (record.name && record.bankDetails && record.bankDetails.bankName && record.bankDetails.accountNumber && record.bankDetails.ifsc && record.bankDetails.accountName
                        && record.name && record.permanentAddress && record.temporaryAddress && record.contactNo && record.personalEmail && record.emergencyPhone && record.emergencyPerson &&
                        record.dob && record.fatherName && record.maritalStatus && record.aadharNumber && record.panNumber && record.sibling && record.medicalIllness && record.salary
                        && record.highestQualification && record.universityorCollege && record.emailPass && record.laptopNumber && record.laptopModel && record.mobileSerial && record.otherOfficialAsset && record.aadharCard.length > 0 && record.panCard.length > 0 && record.academicCertificates.length > 0
                        && record.bankPassbook.length > 0 && record.photo.length > 0) {
                        return (
                            <div style={{ display: 'flex' }}>
                                <span>{record.name}</span>
                                <span><AiFillCheckSquare style={{ background: 'lightgreen', marginLeft: '10px' }} /></span>
                            </div>
                        )
                    } else {
                        return (
                            <div>
                                <span>{record.name}</span>
                            </div>
                        )
                    }
                }
            },
            {
                title: 'UserName / Email',
                dataIndex: 'email',
                key: 'email',
                searchTextName: 'email',
                filterRegex: true
            },
            {
                title: 'Branch',
                key: 'userBranch',
                render: (val, record) => {
                    return (
                        <div>{record.userBranch ? record.userBranch.branchName : ''}</div>
                    )
                }
            },
            {
                title: 'Mobile',
                dataIndex: 'userMobile',
                key: 'userMobile',
                searchTextName: 'Mobile',
            },
            {
                title: 'Verify IP',
                dataIndex: 'verifyIP',
                key: 'verifyIP',
                render: (val, record) => {
                    return <div>
                        <Switch checked={record.verifyIP}
                            onChange={(checked) => {
                                this.changeVerifyIPOnly({ checked, _id: record._id })
                            }}
                        />
                    </div>
                }
            },
            {
                title: 'Profile Edited',
                dataIndex: 'editedByUser',
                key: 'editedByUser',
                render: (val, record) => {
                    return <div>
                        <Switch checked={record.editedByUser}
                            onChange={(checked) => {
                                this.changeEditedByUser({ checked, _id: record._id })
                            }}
                        />
                    </div>
                }
            },
            {
                title: "User Group",
                key: 'userGroup',
                render: (text, record) => (
                    record.userGroup ? (<React.Fragment>
                        <div
                        >
                            <Tooltip title="Click To View Group Details">
                                <a>{record.userGroup.groupName}</a>
                            </Tooltip>
                        </div>

                    </React.Fragment>) : ''
                ),
            },
            {
                title: "Action",
                key: 'operation',
                dataindex: 'operation',
                width: 150,
                render: (text, record) => (
                    <RightsWrapper myRight={"allEmployees.edit"}>
                        <div>
                            <Tooltip title="Update User Status">
                                <Switch checked={record.active}
                                    onChange={(checked) => {
                                        this.changeUserApporval({ checked, _id: record._id })
                                    }} />
                            </Tooltip>
                            <Tooltip title="Change Password">
                                <Button
                                    size={'small'}
                                    shape="circle"
                                    onClick={() => {
                                        this.setState({
                                            changePasswordRecord: record,
                                            drawerVisible: true
                                        })
                                    }}
                                ><FaUserCog /></Button>
                            </Tooltip>
                            <Tooltip title="Update User">
                                <Button
                                    size={'small'}
                                    shape="circle"
                                    onClick={() => {
                                        dispatch(
                                            getUrlPushWrapper('payroll-management.editUser', { id: record._id })
                                        )
                                    }}
                                    icon="edit"
                                />
                            </Tooltip>
                            <Tooltip title="View Details">
                                <Button
                                    size={'small'}
                                    shape="circle"
                                    icon='eye'
                                    onClick={() => {
                                        this.setState({
                                            viewDetailRecord: record,
                                            detailDrawerVisible: true
                                        })
                                    }}
                                ></Button>
                            </Tooltip>
                        </div>
                    </RightsWrapper>
                )
            }
        ]
        return (
            <PageHeaderWrapper title={id ? 'Edit Employee' : 'EMPLOYEE MANAGEMENT'}>
                {
                    this.state.showSyncForm ? (
                        <SyncEmployeeDetailsForm onClose={this.closeSyncForm} />
                    ) : null
                }
                {
                    this.state.detailDrawerVisible ? (
                        <ViewEmployeeDetails onClose={this.closeDetailForm} record={viewDetailRecord} />
                    ) : null
                }
                <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                    <Card bordered={true} >
                        <Button
                            type="primary"
                            htmlType="submit"
                            style={{ marginBottom: 10 }}
                            loading={this.props.loading}
                        >SAVE</Button>
                        <Button
                            type={'primary'}
                            onClick={() => { this.setState({ showSyncForm: true }) }}
                            style={{ marginLeft: "20px" }}
                        >Sync Employee Details</Button>
                        <Tabs type="card" onChange={this.callback}>
                            {/* Add User Tab */}
                            <TabPane tab={id ? "Edit Employee" : "Add Employee"} key={0}>
                                {id ? null :
                                    <Row>
                                        <Col>
                                            <Card
                                                title="General Information"
                                                style={{ marginTop: "40px", marginRight: "10px" }}>
                                                <GetAllFormFields
                                                    apiurl={API_URL}
                                                    inputSchema={inputTypes}
                                                    refresh={this.refreshFxn}
                                                    getFieldDecorator={getFieldDecorator}
                                                />
                                            </Card>
                                        </Col>
                                    </Row>
                                }
                                {id ?
                                    <Row>
                                        <Col span={10}>
                                            <Card
                                                title="Bank Details"
                                                style={{ marginRight: "10px", textAlign: "center" }}>
                                                <GetAllFormFields
                                                    apiurl={API_URL}
                                                    inputSchema={BankDetailInputTypes}
                                                    refresh={this.refreshFxn}
                                                    getFieldDecorator={getFieldDecorator}
                                                />
                                            </Card>
                                            <Card
                                                title="Academic Details"
                                                style={{ marginTop: "40px", marginRight: "10px", textAlign: "center" }}>
                                                <GetAllFormFields
                                                    apiurl={API_URL}
                                                    inputSchema={academicDetailInputTypes}
                                                    refresh={this.refreshFxn}
                                                    getFieldDecorator={getFieldDecorator}
                                                />
                                            </Card>
                                            <Card
                                                title="Previous Experience"
                                                style={{ marginTop: "40px", marginRight: "10px", textAlign: "center" }}>
                                                <GetAllFormFields
                                                    apiurl={API_URL}
                                                    inputSchema={previousExpierenceInputTypes}
                                                    refresh={this.refreshFxn}
                                                    getFieldDecorator={getFieldDecorator}
                                                />
                                            </Card>
                                            <Card
                                                title="Current Employment Details"
                                                style={{ marginTop: "40px", marginRight: "10px", textAlign: "center" }}>
                                                <GetAllFormFields
                                                    apiurl={API_URL}
                                                    inputSchema={currentEmploymentInputTypes}
                                                    refresh={this.refreshFxn}
                                                    getFieldDecorator={getFieldDecorator}
                                                />
                                            </Card>
                                            <Card
                                                title="OnBoarding Details"
                                                style={{ marginTop: "40px", marginRight: "10px", textAlign: "center" }}>
                                                <GetAllFormFields
                                                    apiurl={API_URL}
                                                    inputSchema={onBoardingInputTypes}
                                                    refresh={this.refreshFxn}
                                                    getFieldDecorator={getFieldDecorator}
                                                />
                                            </Card>
                                            <Card style={{ textAlign: 'center' }}>
                                                <Button onClick={() => this.handleGenerateAppointmentLetter(user)} style={{ marginLeft: "10px" }}>Generate Appointment Letter</Button>
                                                <Button onClick={() => this.handleGenerateAgreement(user)} >Generate Employee Agreement</Button>
                                            </Card>
                                            <Card style={{ textAlign: 'center' }}>
                                                <Button style={{ marginLeft: "10px" }} onClick={() => this.handleGenerateAppraisal(user)} >Generate Appraisal Letter</Button>
                                                <Button onClick={() => this.handleGenerateExperience(user)} >Generate Experience Letter</Button>
                                            </Card>
                                        </Col>
                                        <Col span={14}>
                                            <Card
                                                title="General Information"
                                                style={{ textAlign: "center" }}>
                                                <GetAllFormFields
                                                    apiurl={API_URL}
                                                    inputSchema={generalInformationInputTypes}
                                                    refresh={this.refreshFxn}
                                                    getFieldDecorator={getFieldDecorator}
                                                />
                                            </Card>
                                            <Card
                                                title="Upload Documents"
                                                style={{ marginTop: "40px", textAlign: "center" }}>
                                                <GetAllFormFields
                                                    apiurl={API_URL}
                                                    inputSchema={documentsRequiredInputTypes}
                                                    refresh={this.refreshFxn}
                                                    getFieldDecorator={getFieldDecorator}
                                                />
                                            </Card>
                                            <Card
                                                title="Exit Details"
                                                style={{ marginTop: "40px", textAlign: "center" }}>
                                                <GetAllFormFields
                                                    apiurl={API_URL}
                                                    inputSchema={exitDetailsInputTypes}
                                                    refresh={this.refreshFxn}
                                                    getFieldDecorator={getFieldDecorator}
                                                />
                                            </Card>
                                        </Col>

                                    </Row>
                                    : null}
                            </TabPane>
                            {/* All Users Tab */}
                            <TabPane tab={'All Employees'} key={1} disabled={!!id}>
                                <Row>
                                    <Col span={3} style={{ alignItems: 'center' }}>
                                        <h2>{`Users:- ${this.state.totalUser}`}</h2>
                                    </Col>
                                    <Col span={3}>
                                        <div style={{ textAlign: 'right', marginTop: '15px' }}>
                                            {
                                                rightAuth.checkRights("AllEmployeesExcelExport.view") ?
                                                    <Button type={'default'}
                                                        loading={this.state.exportLoading}
                                                        onClick={() => {
                                                            this.exportExcel()
                                                        }}>Export Excel</Button>
                                                    : null
                                            }
                                        </div>
                                    </Col>
                                </Row>

                                <TableComp
                                    columns={userColumn}
                                    ref={this.table}
                                    extraProps={{ scroll: { x: 1200 } }}
                                    apiRequest={params => this.loadUsers(params, 'user')}
                                    pagination={{
                                        showSizeChanger: true,
                                        defaultPageSize: 200,
                                        pageSizeOptions: ['10', '20', '50', '100', '1000']
                                    }}
                                />
                            </TabPane>
                        </Tabs>
                    </Card>
                </Form>
                {/* Change Password Drawer */}
                <Drawer
                    title="Change Password"
                    placement="right"
                    closable={true}
                    onClose={() => {
                        this.setState({
                            drawerVisible: false
                        })
                    }}
                    visible={drawerVisible}
                    width={400}>
                    <div>
                        <div style={{ textAlign: 'center', padding: 20, fontSize: 18 }}>
                            Change Password for
                            {changePasswordRecord && <b> {changePasswordRecord.name}</b>}
                        </div>

                        <ChangePassword
                            loading={this.props.loading}
                            handleSubmit={async values => {
                                if (values.password !== values.cpassword) {
                                    notification.error({
                                        message: 'Unable to Match Passwords'
                                    })
                                    return false
                                }

                                if (values.password.length < 6) {
                                    notification.error({
                                        message: 'Password too Small'
                                    })
                                    return false
                                }

                                dispatch(showLoader())

                                let x = await Request.changeUserPassword({
                                    _id: changePasswordRecord._id,
                                    password: values.password
                                })

                                if (x.error) {
                                    notification.success({
                                        message: 'User not found',
                                        description: x.msg
                                    })
                                } else {
                                    notification.success({
                                        message: 'Password Changes Successfully'
                                    })
                                }

                                this.setState({
                                    changePasswordRecord: null,
                                    drawerVisible: false
                                })
                                dispatch(hideLoader())
                            }}
                        />
                    </div>
                </Drawer>
            </PageHeaderWrapper>
        )
    }
}


const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AllEmployees)